import React, { useEffect, useState } from 'react'
import { Modal, Form, Input, Button, Select } from 'antd'
import { DocumentUpload } from '@/components/DocumentUpload'
import type { Promotion } from '../types/promotion.types'

const { Option } = Select

interface PromotionFormModalProps {
    open: boolean
    onCancel: () => void
    onSubmit: (values: any) => void
    initialValues: Promotion | null
    isSubmitting?: boolean
}

export const PromotionFormModal: React.FC<PromotionFormModalProps> = ({
    open,
    onCancel,
    onSubmit,
    initialValues,
    isSubmitting = false,
}) => {
    const [form] = Form.useForm()

    useEffect(() => {
        if (open) {
            if (initialValues) {
                form.setFieldsValue(initialValues)
            } else {
                form.resetFields()
            }
        }
    }, [open, initialValues, form])

    const handleOk = async () => {
        try {
            const values = await form.validateFields()
            onSubmit(values)
        } catch {
            // Validation failed
        }
    }

    return (
        <Modal
            title={initialValues ? 'Edit Promotion' : 'Add New Promotion'}
            open={open}
            onOk={handleOk}
            onCancel={onCancel}
            confirmLoading={isSubmitting}
            width={600}
            destroyOnHidden
        >
            <Form form={form} layout="vertical">
                <Form.Item name="title" label="Main Title" rules={[{ required: true, message: 'Title is required' }]}>
                    <Input placeholder="e.g. Premium TMT Steel" />
                </Form.Item>
                <Form.Item name="subtitle" label="Subtitle / Offer" rules={[{ required: true, message: 'Subtitle is required' }]}>
                    <Input placeholder="e.g. Flat 15% Off on Bulk Orders" />
                </Form.Item>
                <Form.Item name="image_url" label="Banner Image" rules={[{ required: true, message: 'Please upload a banner image' }]}>
                    <DocumentUpload documentType="promotion_image" />
                </Form.Item>
                <Form.Item name="action_url" label="Action URL (Optional)">
                    <Input placeholder="Deep link or URL when banner is tapped" />
                </Form.Item>
                <Form.Item name="status" label="Status" initialValue="active">
                    <Select>
                        <Option value="active">Active</Option>
                        <Option value="inactive">Inactive</Option>
                    </Select>
                </Form.Item>
            </Form>
        </Modal>
    )
}
